import classNames from 'classnames';
import { FC, PropsWithChildren } from 'react';

import styles from './Skeleton.styles.m.css';

interface ISkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  className?: string;
  isAnimated?: boolean;
  animationConfig?: ISkeletonAnimationConfig;
}

interface ISkeletonAnimationConfig {
  duration?: number;
  loaderWidth?: string;
  startPosition?: string;
  endPosition?: string;
}

const DEFAULT_SKELETON_ANIMATION_CONFIG: ISkeletonAnimationConfig = {
  duration: 1600,
  loaderWidth: '50px',
  endPosition: '100%',
};

export const Skeleton: FC<PropsWithChildren<ISkeletonProps>> = (props) => {
  const { width, height, borderRadius, className, children, isAnimated = true } = props;
  const isSyncMode = props.animationConfig?.startPosition || props.animationConfig?.endPosition;

  const containerClassName = classNames(styles.container, className, {
    [styles.animated]: isAnimated,
  });

  const animationConfig = {
    ...DEFAULT_SKELETON_ANIMATION_CONFIG,
    ...props.animationConfig,
  };

  if (!animationConfig.startPosition) {
    animationConfig.startPosition = `-${animationConfig.loaderWidth}`;
  }

  const style = {
    width,
    height,
    borderRadius,
    '--skeleton-loader-animation-duration': `${animationConfig?.duration}ms`,
    '--skeleton-loader-width': animationConfig?.loaderWidth,
    '--skeleton-loader-start-position': animationConfig.startPosition,
    '--skeleton-loader-end-position': animationConfig.endPosition,
    ...(isSyncMode && {
      '--skeleton-loader-animation-iteration-count': '1',
      '--skeleton-loader-animation-timing-function': 'linear',
    }),
  };

  return (
    <span
      style={style}
      className={containerClassName}
    >
      {children}
    </span>
  );
};
